import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { environment_state } from 'src/app/config';
import packageInfo from '../../../../package.json';
import version from 'src/assets/version.json';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { UtilitiesService } from 'src/app/shared/utilities/utilities.service';
import { interval, Subscription } from 'rxjs';

// TODO: Check and remove this file if it's not used

@Component({
  selector: 'app-universal-app',
  templateUrl: './universal-app.component.html',
  styleUrls: ['./universal-app.component.css']
})

export class UniversalAppComponent implements OnInit {
  userName: string;
  accountNo: string;
  imgsrc: any;
  notifCount: any;
  commentsList = false;
  nameCahngeSubscription: Subscription;
  unreadMessageSubscrition: Subscription;
  kycStatusSubscrition:Subscription;
  intervalId:any;
  messagebizId='';
  biz='';
  bizId='';
  business = '';
  businessList = [];
  messageBusinessList = [];
  kycStatus=0;
  public env = environment_state;
  url: string;
  code: any;
  responseURL:string;
  businessId: string;
  token:string;
  urlSafe: SafeResourceUrl;
  idSubscription: Subscription;
  loggedinEmail = sessionStorage.getItem('userEmail');
  
 
  constructor(private route: ActivatedRoute, private router: Router, private dialog: MatDialog,
    private _api: ApiService
    , private spinner: NgxSpinnerService
    , private cookie: CookieService
    , private sanitizer: DomSanitizer
    , private _utilityService: UtilitiesService    

    ) { 
      if(packageInfo.version.toString() !== version.build_version.toString()){
        window.location.reload();
        localStorage.clear();
        sessionStorage.clear();
        this.cookie.deleteAll('/');
      }

     }
    
     ngOnInit(): void {
      this.nameCahngeSubscription = this._utilityService.nameChange.subscribe((event) => {
        this.getUserData();
      });
      this.isValidToken();
      this.idSubscription = this._utilityService.currentBusinessID.subscribe((ID) => {
        console.log('-------------auth-universal', ID);
      this.businessId = ID;       
      }); 
    if (this.businessId === null || this.businessId === undefined || this.businessId === '') {
        this._api.functionPOST('user/getUserEditableBusinesses', {}).subscribe((response) => {
          if(response['data'].length>=0){
            this.businessId = response['data'][0].bp_business_id;
            this.getRetoolApp();
        }
          });
      } else {

        this.getRetoolApp();
      }
      
    }

    private timeoutId: any;

    ngOnDestroy() {
      if(this.timeoutId){
        clearTimeout(this.timeoutId);
      }
    }
    isValidToken() {
      this._api.functionPOST('user/getApprovedBusinessCount', {}).subscribe((res) => {
         if (res['data']['is_approved_once']=='N') {
          this.kycStatus = 2;
        }
      })
    }

    getUserData() {
      // const data = {
      //   user_id: this.cookieService.get('user_id'),
      // };
       this._api.functionPOST('user/getUserDetailsById', {}).subscribe((res) => {
         const userdetails = res['data']['userData'];
        sessionStorage.setItem('userEmail', userdetails['email']);
        const firstname = userdetails.firstname;
        const middlename = userdetails.middlename ? userdetails.middlename : '';
        const lastname = userdetails.lastname;
        this.userName = firstname + ' ' + middlename + ' ' + lastname;
        this._utilityService.creatorID = userdetails.um_user_id;
        this.accountNo = res['data']['userData'].account_id;
      });
    }
    getRetoolApp() {

      let lpu="";
      let group;
      if (this.env == "test") {
        lpu = "36c514be-b982-11ee-a77a-8fbdc6d3b155";
        group = 1932405;
   } else if (this.env == "development") {
        lpu = "18472d6e-dd8c-11ee-9700-137bf2bcb872";
        group = 1932405;
     } else if (this.env == "demo") {
        lpu = "cb8fad98-dd6d-11ee-a6b0-a7380740ec91";
        group = 1932405;
     } else if (this.env == "production") {
      lpu = "99567ab6-3b18-11ee-b6d6-8f8d3bff157d";
      group = 1932405;
     }


     const data = {
 
      "landingPageUuid": lpu,
        "groupIds": [group],
        "metadata": {
          rbname: this.businessId
        },
        component_name:"UniversalApp"

      }

     const Link = "integrations/generateUniversalAppEmbedURL";
     this.token = this.cookie.get('token');
     this.spinner.show();


this._api.functionPOST(Link, data, this.token).subscribe((response) => {

        this.responseURL = response['data']['embedUrl']+"?_environment=" + this.env;        
        this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.responseURL);        
        this.spinner.hide();      
      });


    }


  
  }

 